import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ConfirmPopup {
  id: string;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
  onConfirm: () => void;
  onCancel?: () => void;
}

@Injectable({ providedIn: 'root' })
export class PopupConfirmService {
  private confirmSubject = new BehaviorSubject<ConfirmPopup | null>(null);
  readonly confirm$ = this.confirmSubject.asObservable();

  showConfirm(config: Omit<ConfirmPopup, 'id'>): void {
    const id = `${Date.now()}-${Math.random()}`;
    const confirmPopup: ConfirmPopup = {
      id,
      title: config.title,
      message: config.message,
      confirmText: config.confirmText || 'Confirmar',
      cancelText: config.cancelText || 'Cancelar',
      type: config.type || 'danger',
      onConfirm: config.onConfirm,
      onCancel: config.onCancel,
    };

    this.confirmSubject.next(confirmPopup);
  }

  showDeleteConfirm(itemName: string, onConfirm: () => void): void {
    this.showConfirm({
      title: '¿Eliminar elemento?',
      message: `¿Estás seguro de que deseas eliminar "${itemName}"? Esta acción no se puede deshacer.`,
      confirmText: 'Eliminar',
      cancelText: 'Cancelar',
      type: 'danger',
      onConfirm,
    });
  }

  showLogoutConfirm(onConfirm: () => void): void {
    this.showConfirm({
      title: '¿Cerrar sesión?',
      message: '¿Estás seguro de que deseas cerrar sesión?',
      confirmText: 'Cerrar sesión',
      cancelText: 'Cancelar',
      type: 'warning',
      onConfirm,
    });
  }

  dismiss(): void {
    const current = this.confirmSubject.value;
    if (current?.onCancel) {
      current.onCancel();
    }
    this.confirmSubject.next(null);
  }

  confirm(): void {
    const current = this.confirmSubject.value;
    if (current?.onConfirm) {
      current.onConfirm();
    }
    this.confirmSubject.next(null);
  }
}
